"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = "mdc-card";
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/card/lib/constants.js
// module id = ./node_modules/@react-mdc/card/lib/constants.js
// module chunks = 1